import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MetaReducer, StoreModule } from '@ngrx/store';

import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { CoreModule } from '@app/core';
import { EffectsModule } from '@ngrx/effects';
import { AppComponent } from './app.component';
import { AppRoutingModule }     from './app-routing.module';

import { AuthModule } from '@app/auth';

// import { AngularFireAuthModule } from 'angularfire2/auth';
// import { AngularFireModule } from 'angularfire2';
import { environment } from './../environments/environment';
// auth reducer

import { reducers } from './store/app.states';
//import { UserService } from '@app/core';

// effects
import { AuthEffects } from '@app/store/effects/auth.effects';
import { ProjectEffects } from '@app/store/effects/project.effects';
import { JobEffects } from '@app/store/effects/job.effects';
import { StudioEffects } from '@app/store/effects/studio.effects';
import { TeamEffects } from '@app/store/effects/team.effects';
import { OfferEffects } from '@app/store/effects/offer.effects';
import { DocumentSegmentEffects } from '@app/store/effects/documentSegment.effects';
import { ProductEffects } from '@app/store/effects/product.effects';
import { MediaEffects } from '@app/store/effects/media.effects';
import { NotificationEffects } from '@app/store/effects/notification.effects';
import { ReportEffects } from '@app/store/effects/report.effects';
//import { ProjectService } from '@app/core';

// import { HTTP_INTERCEPTORS } from '@angular/common/http';
// import { TokenInterceptor } from '@app/core/services/token.interceptor';
//import { NgDragDropModule } from 'ng-drag-drop';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,

    // auth module
    AuthModule,

    // core module
    CoreModule,

    // ngrx
    StoreModule.forRoot(reducers, {}),
    EffectsModule.forRoot([AuthEffects
      ,ProjectEffects
      ,JobEffects
      ,StudioEffects
      ,TeamEffects
      ,OfferEffects
      ,DocumentSegmentEffects
      ,ProductEffects
      ,MediaEffects
      ,NotificationEffects
      ,ReportEffects
    ]),

    // won't work when in shared.module so have to import here
    //NgDragDropModule.forRoot()


  ],
  providers: [
    EffectsModule,
    // {
    //     provide: HTTP_INTERCEPTORS,
    //     useClass: TokenInterceptor,
    //     multi: true
    // }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/app.module.ts